import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { AuthComponent } from "../login/auth.component";
import { LoginService } from "../login/login.service";
import { NoteService } from "./note.service";

import * as _ from "underscore";

@Component({
  selector: "app-note",
  templateUrl: "./note.component.html",
  styleUrls: ["./note.component.css"],
  providers: [NoteService]
})
export class NoteComponent extends AuthComponent implements OnInit {
  @Input() note;
  @Input() region;
  @Input() assortment;
  @Input() collection;
  @Input() colorId;

  @Input() topImgIdx;
  @Input() collIdx;
  @Input() asrtIdx;
  @Input() topImage;

  // @Output("textNote") params.note = new EventEmitter()
  @Output("notesEvent") notesEvent = new EventEmitter();

  private textareaNote: string;
  private isEdit: boolean = false;
  private isSaving: boolean = false;
  private maxNoteLength: number = 150;

  constructor(
    router: Router,
    loginService: LoginService,
    private noteService: NoteService
  ) {
    super(router, loginService);
  }

  ngOnInit() {
    this.textareaNote = this.topImage.note;
  }

  btnAddNote() {
    this.isEdit = true;
    this.textareaNote = this.topImage.note;
  }

  btnEditNote() {
    this.isEdit = true;
    this.textareaNote = this.topImage.note;
  }

  btnCancelNote() {
    this.isEdit = false;
  }

  btnSaveNote() {
    this.isSaving = true;
    let params = {
      region: this.region,
      assortment: this.assortment,
      collection: this.collection,
      color_id: this.colorId,
      note: this.topImage.note
    };

    this.noteService
      .create(params)
      .then(res => {
        this.note = _.escape(this.topImage.note);
        this.isSaving = false;
        this.isEdit = false;
        this.notesEvent.next(this.topImage);
      })
      .catch(e => {
        this.handleError(e);
        this.isSaving = false;
        this.isEdit = false;
      });
  }

  isNotePresent() {
    return this.note && this.note.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/note/note.component.ts